import React, { useState, useEffect } from "react";
import { Icon, Image, Divider, Header } from 'semantic-ui-react'
import image1 from "../../../assets/locations/climap.png"
const Point16 = () => {
    return (
    <React.Fragment>
      <p>
      Током 500 000 година главне климатске промене пратиле су осцилације нагиба Земљине осе и прецесије. Од неколико стотина језгара подвргнутих стратиграфској анализи у оквиру CLIMAP пројекта, одабрана су два (RC1 1-120 и Е49-18), чије су их локације и својства чиниле идеалним за тестирање орбиталне хипотезе. Геолошки подаци обухватили су резултате мерења три климатски осетљива параметра у два језгра из бушотина дубокоморских седимената. Та језгра су узета у области (у јужном делу Индијског океана) где су ранији радови показали да се седименти таложе довољно брзо да могу сачувати информацију о учесталостима. Мерени су (1) δ180, садржај изотопа кисеоника у планктонским фораминиферама, (2) Ts, процена летње температуре морске површине на месту бушења, добијену статистичком анализом популације радиоларија; и (3) проценат заступљености Cycladophora davisiana,  релативни садржај ове врсте радиоларије која није коришћена приликом одређивања Ts. Из оба језгра су, ради анализе, на сваких 10 цм узимани идентични узорци. Закључено је да су промене у геометрији Земљине орбите, односно Миланковићеви циклуси темељни узрoк смене ледених доба током Квартара.

      </p>
      <Divider horizontal>
        <Header as="h4">
        <Icon name='image' />
        Фотографијa
        </Header>      
      </Divider>
      <Image src={image1} alt="Пројекат КЛИМАП – јужни Индијски океан" fluid />
      

    </React.Fragment>
    )
  }

  export default Point16;

